import { Value, AmountValue, CalculationMode, YearAndMonth } from 'common/interfaces';
import { appTheme } from 'components/AppTheme';
import { Currency } from 'enums';

interface ChartData {
  requiredTotal?: Value;
  portfolioRent?: Value;
  actualRent?: Value;
  insuranceRent?: Value;
  extraIncome?: Value;
}

export interface RentData {
  start: string;
  minStart: string;
  maxStart: string;
  startAge: YearAndMonth;

  calculatedRequiredRent: AmountValue;
  plannedRequiredRent: AmountValue;
  requiredRentCalculationMode: CalculationMode;

  calculatedPortfolioRent: AmountValue;
  plannedPortfolioRent: AmountValue;
  requiredPortfolioRent: AmountValue;
  portfolioRentCalculationMode: CalculationMode;

  retirementIncome: AmountValue;
  durability: YearAndMonth;
  durabilityUntil: string;
  partnerDurability: YearAndMonth | null;
  remainder: AmountValue;
  netIncome: AmountValue;
  addingEnabled: boolean;
  chart: ChartData;
  options: Options;
  inflation: { enabled: boolean; rate: number; valuation: boolean; type: string }
}

interface Options {
  requiredRentCalculationMode: string[];
  portfolioRentCalculationMode: string[];
}

const defaultValue = (currency: Currency) => ({
  value: 0,
  currency: currency
});

export const getInitialValues = (currency: Currency) => ({
  portfolioRentCalculationMode: CalculationMode.NONE,
  calculatedRequiredRent: defaultValue(currency),
  plannedRequiredRent: defaultValue(currency),
  calculatedPortfolioRent: defaultValue(currency),
  plannedPortfolioRent: defaultValue(currency),
  requiredPortfolioRent: defaultValue(currency),
  inflation: { enabled: true, rate: 0, valuation: false, type: ''}
});

const { primary, grey } = appTheme.palette;

export const rentGraphColors: {
  [key: string]: { default: string, original?: string };
} = {
  actualRent: { default: 'black' },
  extraIncome: { default: 'black' },
  graphAllowance: { default: 'black' },
  insuranceRent: { default: 'black' },
  portfolioRent: { default: primary.main, original: grey[300] },
  requiredTotal: { default: grey[700] },
  retirementIncome: { default: 'black' },
  requiredRent: { default: grey[700] },
  allowance: { default: primary.main, original: grey[300] },
};
